import { Instagram, Youtube } from "lucide-react";
import { FadeIn, scrollToId } from "./Shared";

const TikTokIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  </svg>
);

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 pt-16 pb-8 overflow-hidden" data-testid="footer">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10 mb-16">
          <FadeIn>
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold mb-4">Start a project</p>
              <button
                data-testid="footer-book-cta"
                onClick={() => scrollToId("#booking")}
                className="font-display text-4xl md:text-6xl font-extrabold uppercase tracking-tighter text-zinc-100 hover:text-gold transition-colors duration-300"
              >
                Book a shoot
              </button>
            </div>
          </FadeIn>
          <FadeIn delay={0.1}>
            <div className="flex gap-4">
              <a
                data-testid="footer-instagram-link"
                href="https://instagram.com/tomazo.productions"
                target="_blank"
                rel="noreferrer"
                className="w-12 h-12 border border-white/15 flex items-center justify-center text-zinc-300 hover:border-gold hover:text-gold transition-colors duration-200"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                data-testid="footer-tiktok-link"
                href="https://www.tiktok.com/@tomazo.productions"
                target="_blank"
                rel="noreferrer"
                className="w-12 h-12 border border-white/15 flex items-center justify-center text-zinc-300 hover:border-gold hover:text-gold transition-colors duration-200"
                aria-label="TikTok"
              >
                <TikTokIcon />
              </a>
              <a
                data-testid="footer-youtube-link"
                href="https://youtube.com/@TomazoProductions"
                target="_blank"
                rel="noreferrer"
                className="w-12 h-12 border border-white/15 flex items-center justify-center text-zinc-300 hover:border-gold hover:text-gold transition-colors duration-200"
                aria-label="YouTube"
              >
                <Youtube size={18} />
              </a>
            </div>
          </FadeIn>
        </div>

        <div className="overflow-hidden w-full">
          <p className="text-outline-faint font-display font-extrabold uppercase tracking-tighter text-[12vw] leading-[0.85] select-none text-center whitespace-nowrap">
            Tomazo
          </p>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600">
          <span>© 2026 Diego Tomazo — tomazo.productions</span>
          <span>Greater Toronto Area, ON</span>
        </div>
      </div>
    </footer>
  );
}
